export default __webpack_public_path__ + "static/media/Bullet 01.ca1ad507.webp";